"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const agentAdded = graphql_tag_1.default `
  subscription($environmentId: String!) {
    agentAdded(environmentId: $environmentId) {
      environmentId
      agentId
    }
  }
`;
exports.default = agentAdded;
//# sourceMappingURL=agentAdded.js.map